import style from "./card.module.css"
import AppGetIcon from "../../../../common/UI/AppGetIcon";
import Card from "../../../../common/UI/Card";
import CardDashboards from "../../../../common/UI/CardDashboards";
const CardDashboard = ({
  title,
  titlePosition,
  description,
  backgroundColor,
  titleColor,
}: PropsCardDashboard) => {
  return (
    <div className={style.card}>
      <CardDashboards
      >
        <div className={style.container_body}>
          {description}
        </div>
      </CardDashboards>
    </div>
  )
};
export default CardDashboard;
